module.exports = __webpack_public_path__ + "static/faststarter_2018-89e7072c368e55dbdd54eec175d846a1.svg";